import { SiteEnv } from '@pubstack/common/src/site'
import { IconName } from '~/components/Icon'

/**
 * Two sets, kept side by side so adding a `SiteEnv` fails to compile until both have a mark for it.
 *
 * iOS and Android share the phone in either set: the icon set has no mark for either, and whatever draws
 * them names the environment in a tooltip or a label.
 */

/** The filled set, for a card that shows the environments a module supports. */
export const SITE_ENV_ICON_FILLED: Record<SiteEnv, IconName> = { web: 'shiny_web', ios: 'mobile', android: 'mobile', amp: 'bolt' }

/** Line art, to sit at the weight the ad format icons are drawn at beside a name in a table. */
export const SITE_ENV_ICON_OUTLINE: Record<SiteEnv, IconName> = { web: 'desktop', ios: 'mobile', android: 'mobile', amp: 'bolt' }
